//#region Asset Imports

import { $SCOPE_SERVICE_NAME } from '../../../../services/system'
import { DEVICE_SERVICE_NAME } from '../../../../services/device'
import { USER_SESSION_SERVICE_NAME } from '../../../../services/user-session'
import { IMRBaseComponent } from '../../../common/base'
import { AddExternalDeviceController } from './add-external-device.controller'

import * as TEMPLATE from './add-external-device.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'addExternalDevice'

export class AddExternalDeviceComponent extends IMRBaseComponent {
	constructor() {
		super({
			controller: AddExternalDeviceController,
			template: TEMPLATE,
			services: [USER_SESSION_SERVICE_NAME, DEVICE_SERVICE_NAME, $SCOPE_SERVICE_NAME],
		})
	}
}
